// extracted by mini-css-extract-plugin
export default {"box":"FilterCity_box__ZvCI1","input":"FilterCity_input__wavbP"};